import { render, staticRenderFns } from "./IconZoom.vue?vue&type=template&id=58d68b04&scoped=true&"
import script from "./IconZoom.vue?vue&type=script&lang=js&"
export * from "./IconZoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../royaumes/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d68b04",
  null
  
)

export default component.exports